<template>
  <div>
    <a-form>
      <a-result
        :title="order.payState=== 2 ? '支付成功':'支付失败'"
        :is-success="order.payState === 2" sub-title=""
        style="max-width: 560px; margin: 40px auto 0;">
        <template #extra>
          <a-button type="primary" @click="finish">{{order.payState === 2 ? '再次购买' : '重新下单'}}</a-button>
          <a-button style="margin-left: 8px" @click="toOrders">查看订单</a-button>
        </template>
      </a-result>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'Step4',
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    finish () {
      this.$emit('finish')
    },
    toOrders () {
      this.$emit('toOrderList')
    }
  }
}
</script>
<style lang="less" scoped>
  .information {
    line-height: 22px;

    .ant-row:not(:last-child) {
      margin-bottom: 24px;
    }
  }
  .money {
    font-family: "Helvetica Neue",sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 14px;
  }
</style>
